export const groupMembershipRoles = Object.freeze({
  MEMBER: 'member',
  APPLIED: 'applied',
  INACTIVE: 'inactive',
  APPLICATIONREMOVED: 'application_removed',
  INDIRECT: 'indirect',
  DIRECT: 'direct',
});
